import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-center gap-4 mb-6">
      <span className="gold-rule" />
      <span className="eyebrow">{eyebrow}</span>
    </div>
    <h2 className="font-serif-elt text-2xl sm:text-3xl lg:text-4xl font-light tracking-wide text-[var(--elt-ivory)] max-w-3xl leading-snug">{title}</h2>
  </Reveal>
);
